import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UiState } from './ui.state';

export const selectUiState       = createFeatureSelector<UiState>('ui');
export const selectGlobalLoading      = createSelector(selectUiState, s => s.globalLoading);
export const selectSidenavOpen        = createSelector(selectUiState, s => s.sidenavOpen);
export const selectLeftNav            = createSelector(selectUiState, s => s.leftNav);
export const selectRightNav           = createSelector(selectUiState, s => s.rightNav);
export const selectSearchBoxVisible   = createSelector(selectUiState, s => s.searchBoxVisible);
export const selectNavLoading         = createSelector(selectUiState, s => s.navLoading);
export const selectBuildNumber        = createSelector(selectUiState, s => s.buildNumber);
export const selectBuildDate          = createSelector(selectUiState, s => s.buildDate);
export const selectVersionNumber      = createSelector(selectUiState, s => s.versionNumber);
